import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';
import {
  GeneralSetting,
  GeneralSettingEditableField,
  isAiGeneralSettingField,
  mergeGeneralSetting,
} from '../../../../models/general-setting.model';
import { GENERAL_SETTING_FIELD } from '../view-user-report.option';
import { AppConstants } from '../../view-user-profile/app.constants';

@Component({
  selector: 'app-change-modal',
  templateUrl: './change-modal.component.html',
  styleUrls: ['./change-modal.component.css']
})

export class ChangeModalComponent implements OnInit {

  private readonly maxValues: Partial<Record<GeneralSettingEditableField, number>> = {
    skillTestQuestionsCount: 50,
    skillTestPassingPercentage: 100,
  };

  public id: string;
  public value: number = null;

  public disabledBtn = false;
  public successInfo = false;
  public errorInfo = false;
  action: GeneralSettingEditableField;
  title = '';
  obj: GeneralSetting;

  constructor(public activeModal: NgbActiveModal,
    private adminService: AdminService) {
  }

  ngOnInit() {
    this.obj = mergeGeneralSetting(this.obj);
    this.setInitialValue();
  }

  changeFour(value: number) {
    if (value < 0) {
      this.value = 0;
      return;
    }
    const maxValue = this.resolveMaxValue();
    if (maxValue !== null && value > maxValue) {
      this.value = maxValue;
    }
  }

  renameGroup() {
    if (this.disableBtnValidation()) {
      return;
    }
    this.obj[this.action] = this.value;
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;
    this.adminService.changeModalSettings(this.obj).subscribe(
      () => {
        this.successInfo = true;
        this.errorInfo = false;
        this.disabledBtn = false;
        this.activeModal.close(AppConstants.MODAL_RESULT.OK);
      },
      () => {
        this.errorInfo = true;
      }
    );
  }

  disableBtnValidation() {
    return this.value === null;
  }

  private setInitialValue() {
    if (this.value !== null && typeof this.value !== 'undefined') {
      return;
    }
    this.value = this.obj[this.action];
  }

  private resolveMaxValue(): number | null {
    if (this.maxValues[this.action]) {
      return this.maxValues[this.action];
    }
    if (isAiGeneralSettingField(this.action)
      || this.action === GENERAL_SETTING_FIELD.SKILL_TEST_TIME_LIMIT_MINUTES) {
      return null;
    }
    return 100;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/change-modal/change-modal.component.ts